module.exports = __webpack_public_path__ + "resources/img/main01_gov_m.af27c724c694eda4ba384d060bc12b5b.jpg";